import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime, tap } from 'rxjs/operators';
import { clearEmptyProperties } from '@core/utils/filters-utils';
import { BehaviorSubject } from 'rxjs';
import english from '../i18n/en.json';
import spanish from '../i18n/es.json';
import portuguese from '../i18n/pt.json';
var FilterGroupsComponent = /** @class */ (function () {
    function FilterGroupsComponent(formBuilder, fuseTranslationLoaderService) {
        this.formBuilder = formBuilder;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.filterChanged = new BehaviorSubject({
            name_contains: null,
            archived: false
        });
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FilterGroupsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.filtersForm = this.formBuilder.group({
                    name: null,
                    archived: false
                });
                this.filtersForm.valueChanges.pipe(debounceTime(500), tap(function () {
                    var filters = clearEmptyProperties({
                        name_contains: _this.filtersForm.value.name,
                        archived: _this.filtersForm.value.archived
                    });
                    _this.filterChanged.next(filters);
                })).subscribe();
                return [2 /*return*/];
            });
        });
    };
    FilterGroupsComponent.prototype.clearFilters = function () {
        this.filtersForm.patchValue({
            name: null,
            archived: false
        });
    };
    return FilterGroupsComponent;
}());
export { FilterGroupsComponent };
